import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { Trash2, XCircle, CheckCircle } from "lucide-react";

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  entityName = "categorie",
  title,
  message,
}) => {
  const { darkMode } = useTheme(); // 🔥 Dark mode állapot

  const capitalizeFirstLetter = (text) =>
    text.charAt(0).toUpperCase() + text.slice(1);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  const handleConfirm = () => {
    onConfirm(); // Meghívjuk a törlési függvényt
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`fixed inset-0 flex items-center justify-center bg-opacity-80 ${darkMode ? "bg-black" : "bg-gray-500"
          }`}
        style={{ zIndex: 9999 }}
        onClick={(e) => e.target === e.currentTarget && onClose()}
      >
        {/* ✅ Animált Modal */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className={`p-8 rounded-3xl shadow-xl w-[500px] relative ${darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* ❌ Bezárás gomb */}
          <button
            onClick={onClose}
            className="absolute top-2 right-3 text-gray-400 hover:text-red-500 transition text-2xl"
          >
            ✖
          </button>

          {/* 🗑️ Törlés ikon */}
          <div className="flex justify-center mb-4">
            <Trash2 size={48} className="text-red-500" />
          </div>

          {/* 🔥 Figyelmeztető szöveg */}
          <h3
            className={`text-2xl font-semibold text-center ${darkMode ? "text-red-400" : "text-red-600"
              }`}
          >
            Sigur doriți să ștergeți această {entityName}?
          </h3>

          {message && (
            <p className="text-center mt-2 text-sm opacity-70">{message}</p>
          )}

          {/* ✅ Gombok */}
          <div className="flex justify-between mt-6 gap-4">
            {/* ❌ Anulare gomb */}
            <button
              onClick={onClose}
              className={`w-full px-4 py-3 rounded-2xl transition flex items-center justify-center gap-2 text-base font-medium ${darkMode
                  ? "bg-gray-700 text-white hover:bg-gray-600"
                  : "bg-gray-400 text-white hover:bg-gray-500"
                }`}
            >
              <XCircle size={20} /> Anulare
            </button>

            {/* 🗑️ Șterge gomb */}
            <button
              onClick={handleConfirm}
              className={`w-full px-4 py-3 rounded-2xl transition flex items-center justify-center gap-2 text-base font-medium ${darkMode
                  ? "bg-red-700 text-white hover:bg-red-600"
                  : "bg-red-600 text-white hover:bg-red-500"
                }`}
            >
              <Trash2 size={20} /> Șterge
            </button>
          </div>

        </motion.div>
      </div>
    </>
  );
};

export default ConfirmDeleteModal;
